module.exports = __webpack_public_path__ + "img/hxzb-img11.2707502e.png";